<template>
    <div>
        <CCard>
            <CCardHeader class="grey-header d-flex">
                <div class="row flex-flow-column">
                    <CCol>
                        <strong>{{$t('topUpPage.topUpTitle')}}</strong>
                    </CCol>
                    <p
                            class="desc"
                    >{{$t('topUpPage.topUpDesc')}}</p>
                </div>
            </CCardHeader>
               

            <ValidationObserver v-slot="{ handleSubmit }">
                <!-- @submit.prevent="handleSubmit(onSubmitPayForTopUp)" -->
                <CForm>
                    <div>
                        <div class="card-body max-w-1100 m-auto pt-0px">
                            <div class="topup-wrapper">
                                <div class="main">
                                    <!--                                    <label>{{$t('topUpPage.topUpAmt')}}</label>-->

                                    <div class="d-flex flex-flow-wrap">
                                        <div class="currency-name">
                                            <!-- cOrgCurrencyDp -->
                                            <cAgentCurrency
                                                    v-on:input="onCurrencyChange"
                                                    :selValue="currency"

                                                    :ctrlCode="'financeid'"
                                                    :isAllowEmpty="false"
                                                    :isShowCode="false"
                                                    :isMultiple="false"
                                                    :isSearchable="true"
                                                    rules="required"
                                                    label="Select Currency"
                                            />
                                            <!-- <cDropDown class="dpTopalign" v-model="lsCurrencyCode.code" :ctrlName="'code'"
                                                                         :ctrlCode="'name'" :isShowCode="false" :isMultiple="false"
                                                                         :isSearchable="true" :url="getCurrencyCodeURL()" rules="required"
                                            :selValue="lsCurrencyCode"/>-->
                                        </div>

                                        <div  class="currency">
                                            <cTextInputComponent
                                            :id="$t('topUpPage.topUpAmtPl')"
                                            :ref="$t('topUpPage.topUpAmtPl')"
                                              @onInput="onEdit"
                                                    :isAmountField="true"
                                                    @onFocus="onRemoveCurrFormat(topUpAmt)"
                                                    @onBlur="formatTopUpAmt(topUpAmt)"
                                                    v-model="topUpAmt"
                                                    :placeholder="$t('topUpPage.topUpAmtPl')"
                                                    :rules="'required|max:'+getMaxCharacters(topUpAmt) +'|onlynumber|notValidNum'"
                                                    label="Topup Amount"
                                                    :toEmit="true"
                                        @caughtError="scrollToElement"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <!-- <cTextInputComponent :isDisable="true" v-model="topUpFees" :name="$t('topUpPage.topUpFees')"
                                                                   iconName="cil-check" :showIcon="true" :value="topUpAmt"/>
                                              <cTextInputComponent :isDisable="true" v-model="topUpTotalAmt"
                                                                   :name="$t('topUpPage.totalAmt')"/>
                                              <label>{{$t('topUpPage.paymentOptions')}}</label>
                                              <br>
                                              {{selectedValue}}
                                              <CCardBody>
                                                  <cRadio
                                                          v-for="item in lsPaymentOptions" :key="item.code"
                                                          :name="item.code" :value="item.code"
                                                          :label="item.name"
                                                          v-on:input="changeValue(item)" rules="required" :selValue="selectedValue"/>

                                              </CCardBody>

                                <br>-->

                                <!-- <div  v-if="errors && errors[0]" class="invalid-feedback icon">
                                                  <div>
                                                      <span v-show="!selectedValue">Please select payment option</span>
                                                  </div>
                                </div>-->

                                <cPaymentList @getPaySettingsList="getPaySettList"
                                              v-if="isCurrChanged&&currency&&isCPaymentList"
                                              @getSelPayment="getSelectedPay"
                                              :paymentFor="paymentFor"
                                              :selectedPayObject="selectedPayType"
                                />
<!--                                <div class="payment-wrapper feeandtotal-wrap">-->
<!--                                    <div class="head-cus"><p>Payment Fee & Total</p></div>&lt;!&ndash;&ndash;&gt;-->
<!--                                    <div class="feentotal">-->
<!--                                        <div class="fee">-->
<!--                                            <table>-->
<!--                                                <tbody>-->
<!--                                                <tr>-->
<!--                                                    <td>-->
<!--                                                        Payment Fee-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        USD-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        0.75-->
<!--                                                    </td>-->

<!--                                                </tr>-->
<!--                                                <tr>-->
<!--                                                    <td>-->
<!--                                                        Topup Amount-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        USD-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                      100.00-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                <tr class="total-wrap">-->
<!--                                                    <td>-->
<!--                                                        Total Amount-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        USD-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                      100.75-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                </tbody>-->
<!--                                            </table>-->

<!--                                        </div>-->
<!--                                    </div>-->

<!--                                </div>-->
<!--                                <div class="payment-wrapper feeandtotal-wrap">-->
<!--                                    <div class="head-cus"><p>{{$t('topUpPage.paymentRef')}}</p></div>-->
<!--                                    <div class="feentotal">-->
<!--                                        <div class="fee inner-label-none">-->
<!--                                            <div class="row">-->
<!--                                                <div class="col-md-6">-->
<!--                                                    <cTextInputComponent-->
<!--                                                            v-model="paymentReference"-->
<!--                                                            :name="$t('topUpPage.paymentRef')"-->
<!--                                                    />-->
<!--                                                </div>-->
<!--                                            </div>-->


<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                                <br/>
                                <div class="row" v-if="topUpFees">
                                    <div class="col-md-6 mb-15px">
                                        <div class="payment-few-bottom h-100 d-flex flex-flow-column">
                                            <div class=" title">
                                                Reference
                                            </div>
                                            <div class="row flex-flow-column mt-auto" style="margin: 0px -10px;">
                                                <div class="col-md-12">
                                                    <div class="total-wrap input">
                                                        <cTextInputComponent
                                                                v-model="paymentReference"
                                                                :name="$t('topUpPage.paymentRef')"
                                                                :label="$t('topUpPage.paymentRef')"
                                                                rules="max:30"
                                                                placeholder="Ex. Primary Amount"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-15px">
                                        <div class="payment-few-bottom">
                                            <div class=" title">
                                                {{$t('topUpPage.paymentFee')}}
                                            </div>
                                            <div class="pay-table">
                                                <table>
                                                    <tbody>

                                                    <tr>
                                                        <td>
                                                            <cTextInputComponent
                                                                    :currency="getCurrencyCode(currency)"
                                                                    :isDisable="true"
                                                                    v-model="orderAmount"
                                                                    :name="$t('topUpPage.topUpAmt')"
                                                                    :label="$t('topUpPage.topUpAmt')"
                                                                    class="d-none"
                                                            />
                                                            {{$t('topUpPage.topUpAmt')}}
                                                        </td>
                                                        <td>
                                                            {{getCurrencyCode(currency)}}
                                                        </td>
                                                        <td>
                                                            {{orderAmount}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <cTextInputComponent
                                                                    :currency="getCurrencyCode(currency)"
                                                                    :isDisable="true"
                                                                    v-model="topUpFees"
                                                                    :name="$t('topUpPage.topUpFees')"

                                                                    :label="$t('topUpPage.topUpPayFees')"
                                                                    class="d-none"
                                                                    :value="topUpFees"

                                                            />
                                                            {{$t('topUpPage.topUpPayFees')}}
                                                        </td>
                                                        <td>
                                                            {{getCurrencyCode(currency)}}
                                                        </td>
                                                        <td>
                                                            {{topUpFees}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <cTextInputComponent
                                                                    :currency="getCurrencyCode(currency)"
                                                                    :isDisable="true"
                                                                    v-model="topUpTotalAmt"
                                                                    :name="$t('topUpPage.totalAmt')"
                                                                    :label="$t('topUpPage.totalAmt')"
                                                                    class="d-none"
                                                            />
                                                            {{$t('topUpPage.totalAmt')}}
                                                        </td>
                                                        <td>
                                                            {{getCurrencyCode(currency)}}
                                                        </td>
                                                        <td>
                                                            {{topUpTotalAmt}}
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
<!--                                            <div class="row flex-flow-column">-->

<!--                                                <div class="col-md-3">-->
<!--                                                    <div class="total-wrap label">-->
<!--                                                        <cTextInputComponent-->
<!--                                                                :currency="getCurrencyCode(currency)"-->
<!--                                                                :isDisable="true"-->
<!--                                                                v-model="topUpFees"-->
<!--                                                                :name="$t('topUpPage.topUpFees')"-->

<!--                                                                :label="$t('topUpPage.topUpPayFees')"-->
<!--                                                                class="d-none"-->
<!--                                                                :value="topUpFees"-->

<!--                                                        />-->
<!--                                                        <div class="row t-wrap-topup">-->
<!--                                                            <div class="col-6 t-title">-->
<!--                                                                <label>{{$t('topUpPage.topUpPayFees')}}</label>-->
<!--                                                            </div>-->
<!--                                                            <div class="col-6 t-value" >-->
<!--                                                                <label>{{getCurrencyCode(currency)}}</label>-->
<!--                                                                <label> {{topUpFees}}</label>-->
<!--                                                            </div>-->
<!--                                                        </div>-->

<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                                <div class="col-md-3">-->

<!--                                                    <div class="total-wrap label">-->
<!--                                                        <cTextInputComponent-->
<!--                                                                :currency="getCurrencyCode(currency)"-->
<!--                                                                :isDisable="true"-->
<!--                                                                v-model="orderAmount"-->
<!--                                                                name="Topup Amount"-->
<!--                                                                label="Topup Amount"-->
<!--                                                                class="d-none"-->
<!--                                                        />-->
<!--                                                        <div class="row t-wrap-topup">-->
<!--                                                            <div class="col-6 t-title">-->
<!--                                                                <label>Topup Amount</label>-->
<!--                                                            </div>-->
<!--                                                            <div class="col-6 t-value" >-->
<!--                                                                <label>{{getCurrencyCode(currency)}}</label>-->
<!--                                                                <label> {{orderAmount}}</label>-->
<!--                                                            </div>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                                <div class="col-md-3">-->
<!--                                                    <div class="total-wrap label">-->
<!--                                                        <cTextInputComponent-->
<!--                                                                :currency="getCurrencyCode(currency)"-->
<!--                                                                :isDisable="true"-->
<!--                                                                v-model="topUpTotalAmt"-->
<!--                                                                :name="$t('topUpPage.totalAmt')"-->
<!--                                                                :label="$t('topUpPage.totalAmt')"-->
<!--                                                                class="d-none"-->
<!--                                                        />-->
<!--                                                        <div class="row t-wrap-topup">-->
<!--                                                            <div class="col-6 t-title">-->
<!--                                                                <label>{{$t('topUpPage.totalAmt')}}</label>-->
<!--                                                            </div>-->
<!--                                                            <div class="col-6 t-value" >-->
<!--                                                                <label>{{getCurrencyCode(currency)}}</label>-->
<!--                                                                <label> {{topUpTotalAmt}}</label>-->
<!--                                                            </div>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->


<!--                                            </div>-->
                                        </div>
                                    </div>
                                </div>
<!--                                <div class="payment-few-bottom" v-if="topUpFees">-->
<!--                                    <div class=" title">-->
<!--Payment Fee & Total-->
<!--                                    </div>-->
<!--                                    <div class="row flex-flow-column">-->

<!--                                            &lt;!&ndash; <div class="max-width-500px restricted-w-br-r">-->



<!--                                                <cTextInputComponent-->
<!--                                                        :isDisable="true"-->
<!--                                                        :currency="getCurrencyCode(currency)"-->
<!--                                                        v-model="topUpFees"-->
<!--                                                        :name="$t('topUpPage.topUpFees')"-->
<!--                                                        iconName="cil-check"-->
<!--                                                        :showIcon="false"-->

<!--                                                        :label="$t('topUpPage.topUpPayFees')"-->

<!--                                                        :toolTipContent="'?'"-->
<!--                                                        :value="topUpFees"-->
<!--                                                        class="bg-blue-font-bold"-->

<!--                                                />-->

<!--                                            </div> &ndash;&gt;-->
<!--                                        <div class="col-md-3">-->
<!--                                            <div class="total-wrap label">-->
<!--                                                <cTextInputComponent-->
<!--                                                        :currency="getCurrencyCode(currency)"-->
<!--                                                        :isDisable="true"-->
<!--                                                        v-model="topUpFees"-->
<!--                                                        :name="$t('topUpPage.topUpFees')"-->

<!--                                                        :label="$t('topUpPage.topUpPayFees')"-->

<!--                                                        :value="topUpFees"-->

<!--                                                />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                            <div class="col-md-3">-->
<!--                                                <div class="total-wrap label">-->
<!--                                                    <cTextInputComponent-->

<!--                                                            :currency="getCurrencyCode(currency)"-->

<!--                                                            :isDisable="true"-->
<!--                                                            v-model="orderAmount"-->
<!--                                                            name="Topup Amount"-->
<!--                                                            label="Topup Amount"-->
<!--                                                    />-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-3">-->
<!--                                                <div class="total-wrap label">-->
<!--                                                    <cTextInputComponent-->

<!--                                                            :currency="getCurrencyCode(currency)"-->

<!--                                                            :isDisable="true"-->
<!--                                                            v-model="topUpTotalAmt"-->
<!--                                                            :name="$t('topUpPage.totalAmt')"-->
<!--                                                            :label="$t('topUpPage.totalAmt')"-->
<!--                                                    />-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-3">-->
<!--                                                <div class="total-wrap input">-->
<!--                                                    <cTextInputComponent-->
<!--                                                            v-model="paymentReference"-->
<!--                                                            :name="$t('topUpPage.paymentRef')"-->
<!--                                                            :label="$t('topUpPage.paymentRef')"-->
<!--                                                    placeholder="Ex. Primary Amount"/>-->
<!--                                                </div>-->
<!--                                            </div>-->

<!--                                        </div>-->
<!--&lt;!&ndash;                                        <div class="col-md-6">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="max-width-500px restricted-w-br-r ">&ndash;&gt;-->
<!--&lt;!&ndash;                                                &lt;!&ndash;              <label>{{$t('topUpPage.totalAmt')}}</label>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                                                <div class="total-price-payment">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    &lt;!&ndash; :currency="getCurrencyCode(currency)" &ndash;&gt;&ndash;&gt;-->

<!--&lt;!&ndash;                                                    <cTextInputComponent&ndash;&gt;-->
<!--&lt;!&ndash;                                                            :currency="getCurrencyCode(currency)"&ndash;&gt;-->
<!--&lt;!&ndash;                                                            :isDisable="true"&ndash;&gt;-->
<!--&lt;!&ndash;                                                            v-model="topUpFees"&ndash;&gt;-->
<!--&lt;!&ndash;                                                            :name="$t('topUpPage.topUpFees')"&ndash;&gt;-->

<!--&lt;!&ndash;                                                            :label="$t('topUpPage.topUpPayFees')"&ndash;&gt;-->

<!--&lt;!&ndash;                                                            :value="topUpFees"&ndash;&gt;-->

<!--&lt;!&ndash;                                                    />&ndash;&gt;-->
<!--&lt;!&ndash;                                                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                            <br/>&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="max-width-500px restricted-w-br-r">&ndash;&gt;-->
<!--&lt;!&ndash;                                                &lt;!&ndash;              <label>{{$t('topUpPage.paymentRef')}}</label>&ndash;&gt;&ndash;&gt;-->

<!--&lt;!&ndash;                                                <cTextInputComponent&ndash;&gt;-->
<!--&lt;!&ndash;                                                        v-model="paymentReference"&ndash;&gt;-->
<!--&lt;!&ndash;                                                        :name="$t('topUpPage.paymentRef')"&ndash;&gt;-->
<!--&lt;!&ndash;                                                        :label="$t('topUpPage.paymentRef')"/>&ndash;&gt;-->
<!--&lt;!&ndash;                                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                            <br/>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="col-md-6">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="max-width-500px restricted-w-br-r ">&ndash;&gt;-->
<!--&lt;!&ndash;                                                &lt;!&ndash;              <label>{{$t('topUpPage.totalAmt')}}</label>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                                                <div class="total-price-payment">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    &lt;!&ndash; :currency="getCurrencyCode(currency)" &ndash;&gt;&ndash;&gt;-->

<!--&lt;!&ndash;                                                    <cTextInputComponent&ndash;&gt;-->
<!--&lt;!&ndash;                                                  &ndash;&gt;-->
<!--&lt;!&ndash;                                                            :currency="getCurrencyCode(currency)"&ndash;&gt;-->

<!--&lt;!&ndash;                                                            :isDisable="true"&ndash;&gt;-->
<!--&lt;!&ndash;                                                            v-model="topUpTotalAmt"&ndash;&gt;-->
<!--&lt;!&ndash;                                                            :name="$t('topUpPage.totalAmt')"&ndash;&gt;-->
<!--&lt;!&ndash;                                                            :label="$t('topUpPage.totalAmt')"&ndash;&gt;-->
<!--&lt;!&ndash;                                                    />&ndash;&gt;-->
<!--&lt;!&ndash;                                                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--                                </div>-->


                                <!--                                <button  class="btn buttonspace action-c-btn btn-success removewrap"><img-->
                                <!--                                        src="/img/correct.0d4e03c5.svg">{{$t('topUpPage.confirm')}}-->
                                <!--                                </button>-->
                            </div>
                        </div>
                        <cAlertModal v-if="isBookFailAlert"
                                     :show="isBookFailAlert"
                                     :status="0"
                                     :buttonList="getBookFailModalBtns()"
                                     :desc="alertValue"
                        ></cAlertModal>
                        <cAlertModal v-if="isAlertWhileNav"
                                     :buttonList="[
      { name:$t('ticketNowPage.okBtn'),func: navToResultPage,color: 'danger'},]"
                                     :show="isAlertWhileNav"
                                     :status="0"
                                     :desc="alertValue"
                        ></cAlertModal>

                        <cAlertModal v-if="isSelPaymentAlert"
                                     :buttonList="[
      { name:$t('paymentPage.selPayAlertOkBtn'),func: onHideSelPaymentAlert,color: 'danger'},]"
                                     :show="isSelPaymentAlert"
                                     :status="0"
                                     :desc="$t('paymentPage.selectPayAlert')"
                        ></cAlertModal>

                        <footer class="card-footer" v-if="isHideFooter">
                            <div class="row mob-flex-column">

                                <div class="text-right mob-btn-center col">
                                    <div class="row d-flex justify-content-end mob-pr-20px">

                                        <button type="button"
                                                class="btn buttonspace action-c-btn btn-success removewrap"
                                                @click.prevent.once="handleSubmit(onSubmitPayForTopUp)"
                                                v-if="isPaySubmitted"><img
                                                src="/img/correct.0d4e03c5.svg">{{$t('topUpPage.confirm')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    </div>
                </CForm>
            </ValidationObserver>
        </CCard>
    </div>
</template>

<script>
    import cAlertModal from "../../src/components/form/cAlertModal";

    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";

    import apiCalPayFeeForTopUp from "../../src/services/apiCalPayFeeForTopUp";
    import apiPrepaidAgentTopUp from "../../src/services/apiPrepaidAgentTopUp";

    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../src/config/API_DATA";
    import {mapGetters, mapActions} from "vuex";
    import cPaymentList from "../../src/components/payment/cPaymentList";
    import cAgentCurrency from "../../src/components/currency/cAgentCurrency";
    import cOrgCurrencyDp from "../../src/components/currency/cOrgCurrencyDp";

    import {
        parseNumber,
        addClassToBody,
        removeClassBody,
        removeCurrFormat,
        getMaxCharOfAmount,
        getErrorAlertValue,
        handleJWT,
        navigateByHostUrl,
        handleSessionExist
    } from "../../src/util/util";
    import BaseConfiguration from "../../src/config/base.js";
    import cTextInputComponent from "../../src/components/form/cTextInputComponent";
    import cRadio from "../../src/components/form/cRadioButton";
    import cDropDown from "../../src/components/form/cDropDown";
    import Logger from "../services/logger";
    import SERVICE_URL from "../config/API_DATA";
    // import nb from "../translations/validation/nb.json";
    // import en from "../translations/validation/en.json";
    import {
        PATHNAME,
        PAYMENT_FOR,
        COMPONENT_NAME,
        ROUTER_PARAM,
        PROCEED_TO_TYPE
    } from "../../src/util/constants";

    import {ValidationObserver, localize} from "vee-validate";
    import router, {navigate, goBack, reloadCurrentPage,updateDataEdited} from "../router/index";

    // localize({
    //     en: {
    //         messages: en.messages
    //     },
    //     nb: {
    //         messages: nb.messages
    //     }
    // });
    export default {
        name: COMPONENT_NAME.TOPUP,
        components: {
            cTextInputComponent,
            cRadio,
            cDropDown,
            ValidationObserver,
            cAgentCurrency,
            cPaymentList,
            cAlertModal,
            cOrgCurrencyDp
        },
        data: () => ({
            paymentFor: PAYMENT_FOR.TOPUP,
            // selectedValue: {
            //   name: "Credit Card",
            //   code: "cc"
            // },
            orderAmount:null,
            topUpAmt: null,
            topUpFees: null,
            topUpTotalAmt: null,
            paymentReference: '',
            isCPaymentList: true,

            currency: null,
            selectedPayType: {
                paymentsettingsid: null,
                groupId: null
            },
            isCurrChanged: false,

            alertValue: null,
            calculatedPayFee: null,
            isSelPaymentAlert: false, /// show alert to select payment type
            isAlertWhileNav: false, //get confirmation before navigating to results page
            bookingResponse: null, //createBookingRes
            isBookFailAlert: false,
            isPaySubmitted: true,
            isHideFooter: true
        }),
        computed: {

            ...mapGetters("sAgtLogin", {
                sSignInRes: "GET_SIGNIN_RES"
            })
        },
//     watch: {
//     //to format amount in V-Model using filter method
//     topUpFees(val) {
//       try {
//         if (BaseConfiguration.isDebug) console.log(" topUpFees");
//  if(val&&this.currency)
//         {
//         this.topUpFees = this.$options.filters.formatNumber(val,this.getCurrencyCode(this.currency));

//         }
//       } catch (err) {
//         let body = Logger.buildRequest(
//           FILE_NAME.TOPUP,
//           "error while formatting  amount in V-Model using filter method",
//           err.toString(),
//           "changeValue",
//           LOG_TYPE.ERROR
//         );
//         Logger.getResponse(body);
//       }
//     },
//      topUpTotalAmt(val) {
//       try {
//         if (BaseConfiguration.isDebug) console.log(" topUpTotalAmt");
//  if(val&&this.currency)
//         {
//         this.topUpTotalAmt = this.$options.filters.formatNumber(val,this.getCurrencyCode(this.currency));

//         }
//       } catch (err) {
//         let body = Logger.buildRequest(
//           FILE_NAME.TOPUP,
//           "error while formatting  amount in V-Model using filter method",
//           err.toString(),
//           "changeValue",
//           LOG_TYPE.ERROR
//         );
//         Logger.getResponse(body);
//       }
//     }
//   },
        methods: {
            ...mapActions("sPaymentPage", {
                SET_PAY_TYPE_OBJ: "SET_PAY_TYPE_OBJ",
                SET_CREATE_BOOKING_RES: "SET_CREATE_BOOKING_RES"
            }),
            ...mapActions("sPrepaidTopUp", {
                SET_CURRENCY: "SET_CURRENCY",
                SET_PRE_PAID_PAY_RES: "SET_PRE_PAID_PAY_RES"
            }),
            ...mapActions("sCPaymentList", {
                SET_PAYMENT_CURRENCY: "SET_CURRENCY"
            }),

             scrollToElement(pRef) {
                var el = null;
                if(pRef == this.$t('topUpPage.topUpAmtPl')) { 
                     el = this.$refs[this.$t('topUpPage.topUpAmtPl')];
                }
                
                if (el) {
                   
                        el.$el.scrollIntoView({ behavior: "smooth" });
                    
                   
                }
  },

onEdit() {
    try {
      if(BaseConfiguration.isDebug) console.log("onEdit");
      
updateDataEdited(true)
    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.TOPUP,
              "error in onEdit",
              err.toString(),
              "onEdit",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
      
    }, 
            getPaySettList(pPaySettingsLs) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPaySettList");
                    if (!(pPaySettingsLs.length > 0)) {
                        this.isHideFooter = true;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in getPaySettList",
                        err.toString(),
                        "getPaySettList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            async onSubmitPayForTopUp() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onSubmitPayForTopUp");
updateDataEdited(false);
                    if (
                        this.topUpAmt &&
                        this.selectedPayType &&
                        this.selectedPayType.paymentsettingsid
                    ) {
                        let topUpDet = {
                            amount: parseNumber(this.topUpAmt),
                            ref: this.paymentReference,
                            paymentSettingsId: this.selectedPayType.paymentsettingsid,
                            currency: this.getCurrencyCode(this.currency)
                        };
                        let retBookingResponse = await this.createPrepaidAgentTopUp(topUpDet);

                        if (retBookingResponse) {

                            this.bookingResponse = retBookingResponse;
                            this.navByProceedTo(this.bookingResponse);
                        } else {
                            this.reCreatePayBtn();
                            this.toggleBookFailAlert();
                        }
                    } else {
                        this.reCreatePayBtn();
                        this.isSelPaymentAlert = true;
                    }
                    
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in onSubmitPayForTopUp",
                        err.toString(),
                        "onSubmitPayForTopUp",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            reCreatePayBtn() {
                try {
                    if (BaseConfiguration.isDebug) console.log("reCreatePayBtn");
                    this.isPaySubmitted = false;
                    let that = this;
                    setTimeout(() => {
                        that.isPaySubmitted = true;
                    }, 100);

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in reCreatePayBtn",
                        err.toString(),
                        "reCreatePayBtn",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },


            //         async onSubmitPayment() {
            //       try {
            //         if (BaseConfiguration.isDebug) console.log("onSubmitPayment");

            //         if (this.topUpAmt&&this.selectedPayType&&this.selectedPayType.paymentsettingsid) {
            //           // b2bid=Number(this.agencyDet.b2bid.replace(/[^0-9]/g, ''));

            //           let topUpDet = {
            // 	 "amount": parseNumber(this.topUpAmt),
            //     "ref": this.paymentReference,
            //     "paymentSettingsId": this.selectedPayType.paymentsettingsid,
            // 	"currency":this.getCurrencyCode(this.currency)
            // }

            //           await this.getPrepaidAgentTopUp(topUpDet);
            //           this.isTopupDetConfirmed=false;//to close yes/no popup

            //         } else {
            //           this.isTopupConfirmed = false;
            //         }
            //       } catch (err) {
            //         let body = Logger.buildRequest(
            //           COMPONENT_NAME.TOPUP,
            //           "error while approving topup",
            //           err.toString(),
            //           "approvePrepaidAgtTopUp",
            //           LOG_TYPE.ERROR
            //         );
            //         Logger.getResponse(body);
            //       }
            //     },
            ///to call create payment for ticketing api
            async createPrepaidAgentTopUp(pTopUpDet) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("createBookingForTicketing");

                    let bookingReq = apiPrepaidAgentTopUp.buildRequest(pTopUpDet);

                    if (bookingReq) {
                        let bookingRes = await apiPrepaidAgentTopUp.getResponse(
                            bookingReq
                        );
                        this.SET_PRE_PAID_PAY_RES(bookingRes);

                        if (VALIDATE_SUCCESS_RES(bookingRes)) {
                            //VALIDATE_SUCCESS_RES(bookingRes)
                            this.SET_CREATE_BOOKING_RES(bookingRes);

                            if (BaseConfiguration.isDebug) {
                                if (
                                    // to print PNRs in console
                                    bookingRes.data &&
                                    bookingRes.data.data &&
                                    bookingRes.data.data.bookingStatus &&
                                    bookingRes.data.data.bookingStatus.BookingDetails
                                ) {
                                    for (
                                        let t = 0;
                                        t < bookingRes.data.data.bookingStatus.BookingDetails.length;
                                        t++
                                    ) {
                                        console.log(
                                            JSON.stringify(
                                                bookingRes.data.data.bookingStatus.BookingDetails[t].pnr
                                            )
                                        );
                                    }
                                }
                            }

                            ///if booked is true
                            if (
                                bookingRes.data.data &&
                                bookingRes.data.data.isBooked
                            ) {
                                retValue = bookingRes.data.data;
                            } ///if booked false ,but status success
                            else {
                                retValue = bookingRes.data.data;
                                this.handleBookingFailed(retValue);
                            }
                        } else {
                            //if status error
                            retValue = null;
                            let error = getErrorMessage(bookingRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                let isSessionExpired;
                                if(bookingRes){
                                     isSessionExpired = handleSessionExist(bookingRes.data)
                                }
                                if (!isSessionExpired) {
                                    this.alertValue = getErrorAlertValue(error, true, true);
                                }
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in getting response from create booking API",
                        err.toString(),
                        "createBookingForTicketing",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            ///to handling the failed case of booking
            handleBookingFailed(pBookingRes) {
                try {
                    if (BaseConfiguration.isDebug) console.log("handleBookingFailed");

                    //if status success, but it contains error obj
                    let errList = [];
                    if (
                        pBookingRes.hasOwnProperty("bookingStatus") &&
                        pBookingRes.bookingStatus.BookingDetails
                    ) {
                        for (
                            let i = 0;
                            i < pBookingRes.bookingStatus.BookingDetails.length;
                            i++
                        ) {
                            if (
                                pBookingRes.bookingStatus.BookingDetails[i].hasOwnProperty(
                                    "error"
                                )
                            ) {
                                if (
                                    pBookingRes.bookingStatus.BookingDetails[i].error &&
                                    pBookingRes.bookingStatus.BookingDetails[i].error
                                        .constructor === Array
                                ) {
                                    for (
                                        let j = 0;
                                        j < pBookingRes.bookingStatus.BookingDetails[i].error.length;
                                        j++
                                    ) {
                                        errList.push(
                                            pBookingRes.bookingStatus.BookingDetails[i].error[j]
                                        );
                                    }
                                } else {
                                    errList.push(pBookingRes.bookingStatus.BookingDetails[i].error);
                                }
                            }
                            //             else {
                            //               this.alertValue = `Sorry, This booking cant go-through.
                            // Please try with other flight combination.`;
                            //             }
                        }
                    }
                    this.alertValue = errList;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in handleBookingFailed",
                        err.toString(),
                        "handleBookingFailed",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            ///to assign particular values to query to navigate another domain
            getPayQueryValues(pBookingRes) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getPayQueryValues");

                    let param = {};
                    if (pBookingRes) {
                        // param[ROUTER_PARAM.SESSION] = this.$router.currentRoute.query[
                        //   ROUTER_PARAM.SESSION_ID
                        // ];
                        param[ROUTER_PARAM.PROVIDER_ID] = pBookingRes.paymentProviderId;
                        param[ROUTER_PARAM.ORDER_PAYMENT_ID] = pBookingRes.orderPaymentId;
                        param[ROUTER_PARAM.TOKEN] = this.sSignInRes.authorization;
                        if (BaseConfiguration.paymentDebugUrl != null) {
                            param[ROUTER_PARAM.PAYMENT_DEBUG_URL] = BaseConfiguration.paymentDebugUrl;
                        }
                        retValue = param;
                    } else {
                        //handle
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in getPayQueryValues",
                        err.toString(),
                        "getPayQueryValues",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            ///navigate to corresponding pages using proceedTo from booking response
            navByProceedTo(pBookingRes) {
                try {
                    if (BaseConfiguration.isDebug) console.log("navByProceedTo");

                    switch (pBookingRes.proceedTo) {
                        case PROCEED_TO_TYPE.HOLD_PAGE: {
                            navigate(PATHNAME.HOLDPAGE);
                        }
                            break;
                        case PROCEED_TO_TYPE.FLIGHT_RESULTS_PAGE: {
                            if (this.alertValue && !pBookingRes.isBooked) {
                                //if booked failed,having error and proceedTo FlightResultPage

                                this.toggleAlertWhileNav(); ///show alert and navigate to resultpage
                            }
                        }
                            break;
                        case PROCEED_TO_TYPE.PAYMENT_GATEWAY: {
                            let retQuery = this.getPayQueryValues(pBookingRes);

                            if (retQuery) {
                                navigateByHostUrl(PATHNAME.PAYMENTGATEWAY, retQuery);
                            } else {
                                throw "invalid queries";
                            }
                        }
                            break;
                        case PROCEED_TO_TYPE.TICKET_SUCCESS_PAGE: {
                            navigate(PATHNAME.SUCCESSPAGE);
                        }
                            break;

                        default:
                            throw "invalid navigation proceed ";
                            break;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in navByProceedTo",
                        err.toString(),
                        "navByProceedTo",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getBookFailModalBtns() {
                return [
                    {
                        name: this.$t("passInfo.tryAgain"),
                        func: this.reloadCurrentPage,
                        color: "danger"
                    }
                ];
            },

            reloadCurrentPage() {
                try {
                    if (BaseConfiguration.isDebug) console.log("reloadCurrentPage");
                    this.$router.go();
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in reloadCurrentPage",
                        err.toString(),
                        "reloadCurrentPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///to navigate flightResult page from alert
            navToResultPage() {
                try {
                    if (this.$route.path != PATHNAME.FLIGHTRESULTS) {
                        navigate(PATHNAME.FLIGHTRESULTS);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in navToResultPage",
                        err.toString(),
                        "navToResultPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///to show alert,if booking response status error
            onHideSelPaymentAlert() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onHideSelPaymentAlert");

                    this.isSelPaymentAlert = false;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in onHideSelPaymentAlert",
                        err.toString(),
                        "onHideSelPaymentAlert",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///to show alert,if booking response status error
            toggleBookFailAlert() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleBookFailAlert");

                    this.isBookFailAlert = !this.isBookFailAlert;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in toggleBookFailAlert",
                        err.toString(),
                        "toggleBookFailAlert",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///show alert to navigate to resultpage
            toggleAlertWhileNav() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleAlertWhileNav");

                    this.isAlertWhileNav = !this.isAlertWhileNav;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in toggleAlertWhileNav",
                        err.toString(),
                        "toggleAlertWhileNav",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onTopUpDetConfirm() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onTopUpDetConfirm");

                    if (
                        this.topUpAmt &&
                        this.selectedPayType &&
                        this.selectedPayType.paymentsettingsid &&
                        this.currency
                    ) {
                        //  navigateByHostUrl(PATHNAME.PAYMENTGATEWAY,);
                        this.isTopupDetConfirmed = true;
                    } else {
                        this.isTopupDetConfirmed = false;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.SYSTEM_TOPUP,
                        "error in onTopUpDetConfirm",
                        err.toString(),
                        "onTopUpDetConfirm",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getMaxCharacters(pTopUpAmt) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getMaxCharacters");
                    let retMaxValue = getMaxCharOfAmount(pTopUpAmt);

                    return retMaxValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in getMaxCharacters",
                        err.toString(),
                        "getMaxCharacters",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            formatTopUpAmt(pTopUpAmt) {
                if (BaseConfiguration.isDebug) console.log(" formatTopUpAmt");
                try {
                    let retCurrCode = this.getCurrencyCode(this.currency);
                    if (retCurrCode) {
                        this.topUpAmt = this.$options.filters.currencyFormat(
                            pTopUpAmt,
                            retCurrCode
                        );
                    } else {
                        throw "invalid currency selection";
                    }

                    // }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in formatTopUpAmt",
                        err.toString(),
                        "formatTopUpAmt",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            onRemoveCurrFormat(pTopUpAmt) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");

                    this.topUpAmt = removeCurrFormat(pTopUpAmt);
                    this.reCreatePayBtn();
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in onRemoveCurrFormat",
                        err.toString(),
                        "onRemoveCurrFormat",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async getSelectedPay(pPaymentType) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getSelectedPay");
                    if (this.topUpAmt) {
                        this.SET_PAY_TYPE_OBJ(pPaymentType);

                        this.selectedPayType.paymentsettingsid =
                            pPaymentType.paymentsettingsid;
                        this.selectedPayType.groupId = pPaymentType.groupId;
                        let retCurrCode = this.getCurrencyCode(this.currency);
                        let retSelectedPayment = await this.getSelectPayment(
                            this.topUpAmt,
                            pPaymentType.paymentsettingsid,
                            retCurrCode
                        );
                        if (retSelectedPayment) {
                            this.topUpFees = this.$options.filters.formatNumber(retSelectedPayment.fee.toString(), this.getCurrencyCode(this.currency))
                            // this.topUpFees = retSelectedPayment.fee.toString();

                            this.topUpTotalAmt = this.$options.filters.formatNumber(retSelectedPayment.total.toString(), this.getCurrencyCode(this.currency))
this.orderAmount=this.$options.filters.formatNumber(retSelectedPayment.orderAmount.toString(), this.getCurrencyCode(this.currency))
                            // this.topUpTotalAmt = retSelectedPayment.total.toString();
                        }
                    } else {
                         this.$root.$emit("toggle_text_field", true);
                        this.reCreatePayBtn();
                        this.isCPaymentList = false;
                        let that = this;
                       setTimeout(() => {
                            that.isCPaymentList = true;
                        });
                       
                       
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in getSelectedPay",
                        err.toString(),
                        "getSelectedPay",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            async getSelectPayment(pAmount, pPaymentsettingsid, pCurrency) {
                try {
                    let retValue;
                    if (BaseConfiguration.isDebug) console.log("getSelectPayment");
                    let selectPayRequest = apiCalPayFeeForTopUp.buildRequest(
                        pAmount,
                        pPaymentsettingsid,
                        pCurrency
                    );

                    if (selectPayRequest) {
                        let selectPayResponse = await apiCalPayFeeForTopUp.getResponse(
                            selectPayRequest
                        );
                        //         let selectPayResponse={data:  {
                        //     "status": "Success",
                        //     "data": {
                        //         "orderId": null,
                        //         "orderAmount": 2000,
                        //         "fee": 1.25,
                        //         "total": 2001.25,
                        //         "feeId": 3
                        //     }
                        // }}

                        if (VALIDATE_SUCCESS_RES(selectPayResponse)) {
                            //VALIDATE_SUCCESS_RES(selectPayResponse)
                            retValue = selectPayResponse.data.data;
                        } else {
                            let error = getErrorMessage(selectPayResponse);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                //     let isSessionExpired = handleSessionExist(selectPayResponse.data);
                                //  if(!isSessionExpired)
                                //  {
                                this.alertValue = getErrorAlertValue(error);

                                //  }
                            }
                        }
                    } else {
                        throw "invalid select payment request";
                    }
                    return retValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.PAYMENTPAGE,
                        "error in getSelectPayment",
                        err.toString(),
                        "getSelectPayment",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            getOrgCurrencyServiceURL() {
                try {
                    if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
                    return SERVICE_URL.GET_ORG_CURRENCY;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error while getting currency  service url",
                        err.toString(),
                        "getCurrencyServiceURL",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getCurrencyCode(pCurrency) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getCurrencyCode");
                    if (pCurrency) {
                        if (
                            pCurrency.hasOwnProperty("currecycode") &&
                            pCurrency.currecycode.hasOwnProperty("code")
                        ) {
                            retValue = pCurrency.currecycode.code;
                        } else if (pCurrency.hasOwnProperty("code")) {
                            retValue = pCurrency.code;
                        } else {
                            retValue = pCurrency;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in getCurrencyCode",
                        err.toString(),
                        "getCurrencyCode",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            ///to change currency
            onCurrencyChange(selCurrencyObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onCurrencyChange");

                    this.currency = selCurrencyObj;
                    this.formatTopUpAmt(this.topUpAmt); ///to format existing amount while changing currency

                    let retCurr = this.getCurrencyCode(this.currency);
                    this.SET_CURRENCY(retCurr);
                    this.SET_PAYMENT_CURRENCY(retCurr);
                    this.topUpFees = null;
                    this.topUpTotalAmt = null;

                    this.selectedPayType.paymentsettingsid = null;
                    this.selectedPayType.groupId = null;
                    this.isCurrChanged = false;
                    var that = this;

                    setTimeout(() => {
                        this.isCurrChanged = true;
                    });
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error while changing currency",
                        err.toString(),
                        "onCurrencyChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            getCurrencyCodeURL: function () {
                try {
                    if (BaseConfiguration.isDebug) console.log(" getCurrencyCodeURL");
                    return SERVICE_URL.GET_AGENT_SELECTED_CURRENCY;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "error in currency code url",
                        err.toString(),
                        "getCurrencyCodeURL",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            /*getTopUpFees: function () {
                        if (this.topUpAmt) {
                            if (this.topUpAmt != "") {
                                this.topUpFees = Number(this.topUpAmt) * 10 / 100 + '';
                                this.topUpTotalAmt = Number(this.topUpAmt) + Number(this.topUpAmt * 10 / 100) + '';

                              ///
                    //   var num=Number(this.topUpAmt);
                    //   this.topUpAmt= Number(num.toFixed(0)).toLocaleString().split(/\s/).join(',')+''
                              ///
                                // if (this.topUpTotalAmt == "NaN") {
                                //     this.topUpFees = null;
                                //     this.topUpTotalAmt = null;
                                // }
                            } else {
                                this.topUpFees = null;
                                this.topUpTotalAmt = null;
                            }
                        }
                    },*/

            onSubmit: async function () {
                // alert("submitted");
            }
        },
        watch: {
            topUpFees(val) {
                try {
                    if (BaseConfiguration.isDebug) console.log(" topUpFees");
                    let retCurr = this.getCurrencyCode(this.currency);

                    this.topUpFees = this.$options.filters.formatNumber(val, retCurr);

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "",
                        err.toString(),
                        "topUpAmt",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            topUpTotalAmt(val) {
                try {
                    if (BaseConfiguration.isDebug) console.log(" topUpTotalAmt");
                    let retCurr = this.getCurrencyCode(this.currency);
                    this.topUpTotalAmt = this.$options.filters.formatNumber(val, retCurr);
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.TOPUP,
                        "",
                        err.toString(),
                        "topUpAmt",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            }
        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.TOPUP);
        },

        beforeDestroy() {
            removeClassBody();
        },
         mounted() {
           this.$root.$emit("toggle_text_field", true);

        }
    };
</script>

